import i18n from "../../../../utils/translations/i18n";
import Policy from "./policy";

const PasswordPolicy = ({ password, className }) => {
    const { t } = i18n;
    return (
        <div className={className}>
            <Policy password={password} policyName={t('validation.password_upper_case_ui')} policyRegex={/^(?=.*[A-Z]).*$/}/>
            <Policy password={password} policyName={t('validation.password_lower_case_ui')} policyRegex={/^(?=.*[a-z]).*$/}/>
            <Policy password={password} policyName={t('validation.password_symbol_ui')} policyRegex={/^(?=.*[!#$%&'*+\-/=?^_`{|}~.@])(?!.*[^!#$%&'*+\-/=?^_`{|}~.@a-zA-Z0-9]).*$/}/>
            <Policy password={password} policyName={t('validation.password_number_ui')} policyRegex={/^(?=.*[0-9]).*$/}/>
            <Policy password={password} policyName={t('validation.password_length_ui')} policyRegex={/^.{8,64}$/}/>
        </div>
    )
}

export default PasswordPolicy;